define('pwa/Application',['require','Application','pwa/module/MenuModule','pwa/controller/ContactsController','pwa/controller/DashboardController','lib/AppRouter','controller/IndexController','pwa/model/OfflineDataModel','pwa/module/NetworkStatusModule','view/layout/MainLayout'],function (require) {

    var Parent = require('Application');

    var MenuModule = require('pwa/module/MenuModule');
    var ContactsController = require('pwa/controller/ContactsController');
    var DashboardController = require('pwa/controller/DashboardController');
    var AppRouter = require('lib/AppRouter');
    var IndexController = require('controller/IndexController');
    var PwaOfflineDataModel = require('pwa/model/OfflineDataModel');
    var NetworkStatusModule = require('pwa/module/NetworkStatusModule');
    var MainLayout = require('view/layout/MainLayout');

    return Parent.extend({

        _networkStatusModel: null,
        _networkStatusRegion: null,

        initialize: function () {
            Parent.prototype.initialize.apply(this);

            $.ajaxSetup({headers: {
                'X-Is-Pwa': true
            }});
        },

        initLayout: function () {
            this._layout = new MainLayout({
                clientModel: this._clientModel
            });
            this.getRootRegion().show(this._layout);

            this.initModules();
        },

        initModules: function () {
            Parent.prototype.initModules.apply(this);

            this._initNetworkStatusModule();
        },

        _initNetworkStatusModule: function () {
            this.module.networkStatus = new NetworkStatusModule({
                layout: this.getLayout()
            });
        },

        onStart: function () {
            Parent.prototype.onStart.apply(this, arguments);

            PwaOfflineDataModel.getInstance().preloadMissingData();

            this.listenTo(this._clientModel, 'sync', function () {
                PwaOfflineDataModel.getInstance().preloadClientModelRelatedData();
            });

            this.clientLoginListener();
        },

        clientLoginListener: function () {
            var _this = this;

            Backbone.Wreqr.radio.channel('client_login').vent.on('client:ready', function () {
                if (!_this._clientModel.get('is_logged_in')) {
                    if ('client/sign-in' !== Backbone.history.getFragment()) {
                        _this._clientModel.navigateToSignIn();
                    }
                }
            });
        },

        initMoreRoutes: function (controllerParams) {
            var dashboardRouter = new AppRouter({
                appRoutes: {
                    '': 'dashboard',
                },
                menuItem: 'index',
                controller: new DashboardController(controllerParams)
            });

            var contactsRouter = new AppRouter({
                appRoutes: {
                    'contacts(/)': 'contacts',
                },
                menuItem: 'contacts',
                controller: new ContactsController(controllerParams)
            });

            var indexRouter = new AppRouter({
                appRoutes: {
                    'about(/)': 'about',
                },
                menuItem: 'about',
                controller: new IndexController(controllerParams)
            });

            Parent.prototype.initMoreRoutes.apply(this, arguments);
        },

        _initMenuModule: function () {
            this.module.menu = new MenuModule({
                layout: this.getLayout()
            });
        },

    });

});
